module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAMAAACzvE1FAAAAXVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9RKvvlAAAAHnRSTlMAOfXJeAfrukysoLJYJ9POwHBrReTbiGRfPzIeE4DyT1LZAAAAi0lEQVQY053ISRKCMABE0YaQICDIPPvvf0wDRdSFK19VL/rrUM/aSqu00WV1NfSmUNBxqu31N0wCQ4u5Qk5cAQZWnZIsNVlW+HWS9khlFFgbaSAaCZYcwZQQ3AyKuX+F9K8AU/MJFSpcmRN0iZOsmgr6R4wzpX8HG9PqQS7vd9jhKUeqt8ItGt0s7wUkhhKF5ZdTaAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon-android-active.png
// module id = b1za
// module chunks = 0 1